import ENV from "config/Env";
import { backendQueryKey } from "hooks/useTypedQuery";

import type { ChecklistTemplate, ChecklistTemplateID, ChecklistTemplateShort, ReportTemplate } from "models";

const component = "ChecklistSettingsDashboard";

export const ChecklistSettingsDashboardQueryKeys = {
  checklistTemplates: backendQueryKey<ChecklistTemplateShort[]>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/checklists/template/list_short" }),
  reportTemplates: backendQueryKey<ReportTemplate[]>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/report_templates/check/list" }),
  templateDetails: (id: ChecklistTemplateID) =>
    backendQueryKey<ChecklistTemplate>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/checklists/template/details", params: { id } })
};
